(function () {
  'use strict';

  /* @ngdoc object
   * @name cycle
   * @description
   *
   */
  angular
    .module('cycle', [
      'ui.router'
    ]);
}());
